import { get, post, put, patch } from "../Config"

export function SearchNews({ params = {}, lang }) {
  return get({ url: `/v1/admin/news`, params, lang })
}
export function GetNewsById({ id, lang }) {
  return get({ url: `/v1/admin/news/${id}`, lang })
}
export function CreateNews({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/news`, params, data, lang })
}
export function UpdateNews({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/news/${id}`, params, data, lang })
}
export function PatchNews({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/news/${id}`, params, data, lang })
}
export function DeleteNews({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/news/mutiDelete`, params, data, lang })
}
